import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import BranchGateway from '~apis/branch';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TCreateNewBranchReduxParams } from '~types/feat/branch';
import { BranchStatusEnum } from '~utils/enums';

export default function* watchCreateNewBranch(api: BranchGateway): SagaWatcherReturnType {
    yield takeEvery('branch/branchCreateNewBranchAttempt', handleCreateNewBranch, api);
}

function* handleCreateNewBranch(api: BranchGateway, action: PayloadAction<TCreateNewBranchReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        regionId,
        branchCode,
        branchName,
    } = action.payload;

    if (!regionId || !branchCode || !branchName) {
        yield put(combinedActions.branchCreateNewBranchFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.createNewBranch], {
        authToken,
        regionId,
        branchCode,
        branchName,
        branchStatus: BranchStatusEnum.Active,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.branchCreateNewBranchFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.branchCreateNewBranchSuccess());
        yield put(combinedActions.branchSetCreateNewBranchModalIsOpen(false));
        yield put(combinedActions.branchSetGetBranchListingIndex({ index: 0 }));
        yield put(combinedActions.branchGetBranchListingAttempt()); // for rendering the list in branch management
        yield put(combinedActions.branchGetAllBranchesAttempt()); // for filters (separate API to get all)

        toast.success(SuccessMessages.BranchCreateNewBranchSuccess);
    }
}
